






































import { Component, Vue } from 'vue-property-decorator'
import openApp from '@ivy/fts/openApp'
import { env } from '@ivy/fts/envInfo/envInfo'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import shareModal from '../comps/shareModal.vue'
import resultModal from '../comps/resultModal.vue'
import resultComp from '../comps/resultComp.vue'
import * as shareApi from '../api/shareApi'

@Component({
  components: {
    resultComp,
  },
})
export default class extends Vue {
  canTest: boolean = false
  babyUrl: string
  rangeDay: number = 30
  current: any = {}
  last: any = {}
  bookList: object[] = []
  testId: any
  showPage: boolean = false
  async created() {
    if (this.$route.query.fromTest) {
      await this.onReady()
    }
  }
  // 转换蓝思值负号为BR
  changeScore(value) {
    if (value < 0) {
      return 'BR' + -value
    } else {
      return value
    }
  }
  // 监听微信自带返回按钮
  async onReady() {
    window.history.pushState({ url: '#' }, '监听用户返回操作', '#')
    window.onpopstate = () => this.pushHistory()
  }
  // 修改拦截的返回事件
  pushHistory() {
    window.history.pushState({ url: '#' }, '监听用户返回操作', '#')
    window.location.href = `${
      window.location.origin
    }/act2/reimsAssess/index?_hideShareButton=1`
  }
  async mounted() {
    await env.init()
    let loginInfo = await env.getInfo()
    console.log('loginInfo', loginInfo)
    if (env.type === 'ivydad') {
      this.babyUrl =
        loginInfo.userInfo.babyAvatarUrl || loginInfo.userInfo.avatarUrl
    } else {
      this.babyUrl =
        loginInfo.logined.user.baby_avatar_url ||
        loginInfo.logined.user.avatar_url
    }
    await this.getResultData()
    await this.getBookData()
  }
  // 获取结果页面数据
  async getResultData() {
    this.testId = this.$route.query.test_id
    env.type === 'wx' && (await shareApi.share(this.testId))
    let { data } = await shareApi.requireGet(
      '/api/m-course/lexile/getResultByTestId',
      {
        test_id: this.testId,
      }
    )
    this.current = data.current
    this.last = data.last_time
    this.canTest = data.can_test
    this.rangeDay = data.interval_days
    this.showPage = true
  }
  // 获取电子绘本数据
  async getBookData() {
    let { data } = await shareApi.requireGet(
      '/api/audios/resource/book/findByLexile',
      {
        offset: 0,
        limit: 6,
        lexile: this.current.score.b_new,
      }
    )
    this.bookList = data
  }
  // 分享按钮逻辑
  async showShare(type) {
    if (type === 'PT') {
      // 分享蓝思定位测评报告埋点
      await shareApi.getUpload('Share_PlacementTest_Lexile')
    } else {
      // 分享蓝思阶段测评报告埋点
      await shareApi.getUpload('Share_ProgressMonitoringTest_Lexile')
    }
    if (env.type === 'wx') {
      showDiv(shareModal)
    } else {
      await shareApi.share(this.testId)
    }
  }
  // 再测一次逻辑
  again() {
    if (this.rangeDay && this.rangeDay > 180) {
      window.location.href = `${
        window.location.origin
      }/act2/reimsAssess/needKnow?_hideShareButton=1`
    } else {
      showDiv(resultModal, { rangeDay: this.rangeDay })
    }
  }
  // 跳转到下载app
  download() {
    if (env.type === 'ivydad') {
      env.commonJump(`ivydadReadtool://detail/bookAlbum?id=2`)
    } else {
      return openApp()
    }
  }
}
